import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let relationFieldsApiPromise: Promise<AxiosInstance> | null = null;

const getRelationFieldsApi = () => {
  if (relationFieldsApiPromise) return relationFieldsApiPromise;
  relationFieldsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return relationFieldsApiPromise;
};

export interface DeleteHobbiesProps {
  hobbies: number[];
}

export interface DeleteProfesionesProps {
  profesiones: number[];
}

export interface GetSimilarProps {
  nombre: string;
  excluidos?: number[];
}

export interface CreateRelationFieldProps {
  nombre: string;
}

export interface UpdateRelationFieldProps {
  id: number;
  nombre: string;
}

export interface GetRelationFieldDetailProps {
  id: number;
}

export const deleteHobbies = async (props: DeleteHobbiesProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  await api.delete(`/Hobbies/Eliminar?${objectToQueryStringWithArray(props)}`);
};

export const deleteProfesiones = async (props: DeleteProfesionesProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  await api.delete(
    `/Profesiones/Eliminar?${objectToQueryStringWithArray(props)}`,
  );
};

export const getHobbiesSimilares = async (props: GetSimilarProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.get(
    `/Hobbies/GetHobbiesSimilares?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getProfesionesSimilares = async (props: GetSimilarProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.get(
    `/Profesiones/GetProfesionesSimilares?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const createHobbie = async (props: CreateRelationFieldProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.post(
    `/Hobbies/Crear?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const createProfesion = async (props: CreateRelationFieldProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.post(
    `/Profesiones/Crear?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getHobbieDetail = async (props: GetRelationFieldDetailProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.get(
    `/Hobbies?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getProfesionDetail = async (
  props: GetRelationFieldDetailProps,
) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.get(
    `/Profesiones?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const updateHobbie = async (props: UpdateRelationFieldProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.put(
    `/Hobbies/Actualizar?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const updateProfesion = async (props: UpdateRelationFieldProps) => {
  const api = await getRelationFieldsApi();
  if (!api) return;

  const response = await api.put(
    `/Profesiones/Actualizar?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
